import lpApp from '../../app/lp_app';

/*
 * Project: LegalPlace assistant
 * File: src\components\utils\misc.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */

/* eslint-disable */
export function objectLength(ob) {
  let i = 0;
  for (const j in ob) {
    i = j;
  }
  return i;
}


export function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return `${s4() + s4()}-${s4()}-${s4()}-${
    s4()}-${s4()}${s4()}${s4()}`;
}

const lut = []; for (let i = 0; i < 256; i += 1) { lut[i] = (i < 16 ? '0' : '') + (i).toString(16); }


export function generateId1() {
  const d0 = Math.random() * 0xffffffff | 0;
  const d1 = Math.random() * 0xffffffff | 0;
  const d2 = Math.random() * 0xffffffff | 0;
  const d3 = Math.random() * 0xffffffff | 0;
  return `${lut[d0 & 0xff] + lut[d0 >> 8 & 0xff] + lut[d0 >> 16 & 0xff] + lut[d0 >> 24 & 0xff]}-${
    lut[d1 & 0xff]}${lut[d1 >> 8 & 0xff]}-${lut[d1 >> 16 & 0x0f | 0x40]}${lut[d1 >> 24 & 0xff]}-${
    lut[d2 & 0x3f | 0x80]}${lut[d2 >> 8 & 0xff]}-${lut[d2 >> 16 & 0xff]}${lut[d2 >> 24 & 0xff]
  }${lut[d3 & 0xff]}${lut[d3 >> 8 & 0xff]}${lut[d3 >> 16 & 0xff]}${lut[d3 >> 24 & 0xff]}`;
}

export const localFormat = (t) => {
  let res = t;
  if (t < 10) {
    res = `0${t}`;
  }

  return res;
};

export function animationScroll(dest0 = -1) {
  let destY;
  if (dest0 === -1) destY = 125;
  else destY = dest0;
  // debugger;
  const delta = 30;
  const scrollEvent = setInterval(() => {
    if (
      Math.abs(window.scrollY - destY) <= 10
      || (window.innerHeight + window.scrollY) >= document.body.offsetHeight
    ) {
      console.log('animated');

      clearInterval(scrollEvent);
    } else {
      // console.log(window.scrollY)
      if (destY < window.scrollY) {
        window.scrollTo(window.scrollX, window.scrollY - (window.scrollY / delta));
      } else {
        window.scrollTo(
          window.scrollX, window.scrollY + ((window.scrollY < 350 ? 350 : window.scrollY) / delta),
        );
      }
    }
  }, 10);
}


export function scrollAndGoUp() {
  window.scrollTo(window.pageYOffset, 0);
  return true;
}


export function scrollTo(element, to, duration) {
  const start = element.scrollTop;
  const change = to - start;
  let currentTime = 0;
  const increment = 20;
  let timer;
  let killed;

  Math.easeInOutQuad = function (t, b, c, d) {
    t /= d / 2;
    if (t < 1) return c / 2 * t * t + b;
    t -= 1;
    return -c / 2 * (t * (t - 2) - 1) + b;
  };

  const animateScroll = function () {
    if (killed) return;
    currentTime += increment;
    const val = Math.easeInOutQuad(currentTime, start, change, duration);
    element.scrollTop = val;
    if (currentTime < duration) {
      timer = setTimeout(animateScroll, increment);
    }
  };

  animateScroll();

  return {
    stop: () => {
      killed = true;
      clearTimeout(timer);
    },
  };
}
/* eslint-enable */

// ----------------- GLOBALE TRACKING SCROLLE CHIT
window.toctoc = null;
window.scrollingTracker = true;
window.addEventListener('scroll', () => {
  window.scrollingTracker = false;
  if (window.toctoc !== null) {
    clearTimeout(window.toctoc);
  }
  window.toctoc = setTimeout(() => {
    window.scrollingTracker = true;
  }, 150);
});
// gist.

/**
 * @description This funciton creates an array which radio children are put togather.
 * @param {number} id
 * @returns {array}
 */
export function filterComponents(id) {
  const now = lpApp.references.getOption(id);
  if (typeof now === 'undefined') return now;
  const children = [];
  let radios = [];
  const actualChildren = now.children;
  const childrenLength = actualChildren.length;
  // debugger;

  actualChildren.forEach((idx, i) => {
    const _ = lpApp.references.getOption(idx);
    if (_.meta.type !== 'radio') {
      if (radios.length === 0) children.push(idx);
      else {
        children.push(radios);
        radios = [];
        children.push(idx);
      }
    } else {
      radios.push(idx);
      if (radios.length > 0) {
        if (i === (childrenLength - 1)) {
          children.push(radios);
        }
      }
    }
  });
  return children;
}



// WEBPACK FOOTER //
// ./src/components/utils/misc.js